import React, { useEffect, useState } from "react";

import "./LoginForm.scss";
import { EmailInput } from "./EmailInput";
import { CodeInput } from "./CodeInput";
import { UserSessionApi } from "../../system/api/UserSessionApi";
import {dispatch} from "../../App";
import {actions} from "../../redux";
import { useTranslations } from "../../hooks/useTranslations";

const LoginForm = () => {

    const { t } = useTranslations();

    const [emailInput, setEmailInput] = useState<string>('');
    const [codeInput, setCodeInput] = useState<boolean>(false);

    const validateEmail = (email: string) => {
        return String(email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
      };

    const submitEmail = (email:string) => {
        if (validateEmail(email)) {
            setEmailInput(email);
            requestCode(email);
            return;
        }

        setEmailInput('');
    };

    const requestCode = async (email:string) => {
        if (codeInput) {
            return;
        }
        const api = new UserSessionApi();
        const result = await api.requestEmailToken(email);
        if (typeof result === 'undefined') {
            setCodeInput(false);
            return;
        }
        setCodeInput(true);
    };

    const submitCode = async (code: string) => {
        const api = new UserSessionApi();
        const result = await api.requestCodeValidation(emailInput, code);

        if (typeof result === 'undefined') {
            return;
        }

        if (result.success === true && result.token) {
            dispatch(actions.activeUser.setToken(result.token));
            dispatch(actions.activeUser.setEmail(emailInput));
        }
    };

    const prev = () => {
        setCodeInput(false);
    };


    return (<div className="loginForm">
        <div className="card">
            <div className="card-header">{t('welcome.login')}</div>
            {
                codeInput ? <CodeInput
                    onPrevios={prev}
                    onSubmit={submitCode}
                ></CodeInput> : <EmailInput email={emailInput} onSubmit={submitEmail}></EmailInput>
            }
           
        </div>
    </div>);
};

export { LoginForm };
